import Typography from '@/components/common/Typography';
import useEmblaCarousel from 'embla-carousel-react';
import { useRouter } from 'next/router';
import styled from 'styled-components';

export default function RecentViewList({ products }: { products: ExperienceProduct[] }) {
  const [emblaRef] = useEmblaCarousel();
  const router = useRouter();
  const handleClick = (id: number) => () => {
    router.push(`/product/${id}`);
  };

  return (
    <ListContainer>
      <Embla ref={emblaRef}>
        <EmblaContainer>
          {products.map((item, index) => (
            <EmblaSlide key={index} onClick={handleClick(item.id)}>
              <SlideContent>
                <Image src={item.thumbnailUrl} alt={item.name} />
                <InfoConatiner>
                  <FirstRow>
                    <Typography variant="h5" color={'gray900'}>
                      {item.categoryName} • {item.location}
                    </Typography>
                  </FirstRow>
                  <Typography variant="b2" color={'black'}>
                    {item.name}
                  </Typography>
                  {/* {item.date && <Date>{item.date}</Date>}
            {item.people && <People>{item.people}</People>} */}
                </InfoConatiner>
              </SlideContent>
            </EmblaSlide>
          ))}
        </EmblaContainer>
      </Embla>
    </ListContainer>
  );
}

const Embla = styled.div`
  overflow: hidden;
  width: 100%;
`;

const EmblaContainer = styled.div`
  display: flex;
`;

const EmblaSlide = styled.div`
  position: relative;
  min-width: 300px;
  padding: 10px;
  border: 1px solid ${({ theme }) => theme.colors.gray200};
  border-radius: 10px;
  margin-right: 10px;
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const FirstRow = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const SlideContent = styled.div`
  display: flex;
  width: 100%;
`;

const Image = styled.img`
  width: 60px;
  height: 60px;
  border-radius: 8px;
  margin-right: 10px;
`;

const InfoConatiner = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 3px;
`;

const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;
